export const isMobile = () => document.documentElement.clientWidth <= 413;
export const isTablet = () => document.documentElement.clientWidth >= 414 && document.documentElement.clientWidth <= 1023;
export const isDesktop = () => document.documentElement.clientWidth >= 1024;
